// extracted by mini-css-extract-plugin
var _1 = "personalData-module_checkboxMainWrap_coDTw";
var _2 = "personalData-module_closeIcon_ARm90";
var _3 = "personalData-module_personalButtonElement_elW2E";
var _4 = "personalData-module_personalButtonWrapper_oeYlq";
var _5 = "personalData-module_personalCheckboxWrapper_aqsRt";
var _6 = "personalData-module_personalHeaderWrapper_UOTW1";
var _7 = "personalData-module_personalInputWrapper_efY6q";
var _8 = "personalData-module_personalInputWrapper1_l7xLQ";
var _9 = "personalData-module_personalMainWrapper_ck8Cb";
var _a = "personalData-module_personalWrapper_jXmC_";
export { _1 as "checkboxMainWrap", _2 as "closeIcon", _3 as "personalButtonElement", _4 as "personalButtonWrapper", _5 as "personalCheckboxWrapper", _6 as "personalHeaderWrapper", _7 as "personalInputWrapper", _8 as "personalInputWrapper1", _9 as "personalMainWrapper", _a as "personalWrapper" }
